import { FC } from "react";
import styled from "styled-components/native";
import InfoAlertIcon from "@/assets/icons/auth/infoAlertIcon.svg";

interface IFormAlertProps {
  textInfo: string;
}

const InfoAlert: FC<IFormAlertProps> = ({ textInfo }) => {
  return (
    <Container>
      <IconWrapper>
        <InfoAlertIcon width={20} height={20} />
      </IconWrapper>
      <TextContainer>
        <AlertText>{textInfo}</AlertText>
      </TextContainer>
    </Container>
  );
};

export default InfoAlert;

const Container = styled.View`
  flex-direction: row;
  align-items: flex-start;
  border: 1px solid rgba(22, 119, 255, 0.20);
  background-color: rgba(22, 119, 255, 0.10);
  padding: 12px;
  border-radius: 16px;
  min-height: 60px;
`;

const IconWrapper = styled.View`
  margin-right: 8px;
`;

const TextContainer = styled.View`
  flex: 1;
`;

const AlertText = styled.Text`
  font-size: 16px;
  line-height: 22px;
  color: #101928;
  font-weight: 400;
`;
